import React, { PropsWithChildren } from "react";
import styles from "./AmpInfoWrapper.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export interface AmpInfoWrapperProps extends PropsWithChildren {
    showIcon?: boolean;
}

export default function AmpInfoWrapper(props: AmpInfoWrapperProps){
    return (
        <div className={styles.infotop}>
            <div className={styles.icon}>
                {props.showIcon && <FontAwesomeIcon icon={faInfoCircle} size={"2x"}/>}
            </div>
            <div className={styles.info}>
                {props.children}
            </div>
        </div>
    )
}